<template>
  <div>
    <div class="">
      <div class="filter">
        <el-form
          :inline="true"
          @submit.native.prevent
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="80px"
          size="small"
          class="oneline"
        >
          <el-form-item label="成品分类">
            <TemplateSelect
              v-model="filter.product_template_id"
              :category="category"
              :asset-type="2"
            ></TemplateSelect>
          </el-form-item>
          <el-form-item label="钻井" v-if="category == 2">
            <DrillWellSelect
              v-model="filter.drill_well_id"
              :clearable="true"
            ></DrillWellSelect>
          </el-form-item>
          <el-form-item label="统计月份" prop="month">
            <el-date-picker
              v-model="filter.month"
              type="month"
              size="small"
              placeholder="选择月份"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="getData(true)">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="">
      <div style="display: flex; justify-content: end">
        <file-button
          obj="product_well_period"
          :filter="queryData"
          :importButton="false"
        ></file-button>
      </div>
      <Table
        :items="items.list"
        :category="category"
        :loading="loading"
      ></Table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="items.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { productWellPeriodList } from '@/service/getData'
import Table from './table'
import TemplateSelect from '@/components/select/product_template_select'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Table,
    TemplateSelect,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.category = this.category
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        product_template_id: '',
        drill_well_id: '',
        month: this.$time(Date.now()).format('YYYY-MM'),
        page: 1,
        size: 10,
        tab: 'well_used_data',
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      if (filter.tab == 'well_used_data') {
        this.filter = filter
      }
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.product_template_id = ''
        this.filter.drill_well_id = ''
        this.filter.month = this.$time(Date.now()).format('YYYY-MM')
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await productWellPeriodList(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>